/**
 * DescriptionFacts element.
 */
import ChannelText from '@components/atoms/text/descriptionFactsChannelText';
import Container from '@components/atoms/container/descriptionFactsContainer';
import Context from '@shared/components/utils/context/descriptionContext';
import RestText from '@components/atoms/text/descriptionFactsRestText';
import { useContext } from 'react';

/**
 * Renders description facts from context (`useMetadata` → `channelTitle`, `factsLine`).
 */
export default function DescriptionFacts() {
  const { metadata } = useContext(Context);
  const channelTitle = metadata?.channelTitle;
  const factsLine = metadata?.factsLine;
  if (!channelTitle && !factsLine) return null;

  return (
    <Container id='descriptionFactsContainer'>
      {channelTitle ? (
        <ChannelText id='descriptionFactsChannel'>{channelTitle}</ChannelText>
      ) : null}
      {factsLine ? (
        <RestText id='descriptionFactsRest' margin={!!channelTitle}>
          {channelTitle ? `| ${factsLine}` : factsLine}
        </RestText>
      ) : null}
    </Container>
  );
}
